const SvgIcon = ({size = 16, color = '#000' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={''+size}
    height={''+size}
    fill="none"
    version="1.1"
    viewBox="0 0 16 16"
  >
    <path
      fill={color}
      strokeWidth="1"
      d="M8 1.143c2.817 0 4.415 1.799 4.647 3.97h.07C14.53 5.113 16 6.527 16 8.271s-1.47 3.158-3.282 3.158l-.804-.001-.015.039-1.694 3.09a.571.571 0 0 1-1.045-.453l.041-.095 1.416-2.58H8.5l-.016.039-1.694 3.09a.571.571 0 0 1-1.045-.453l.041-.094 1.416-2.582H5.065L3.36 14.557a.57.57 0 0 1-.68.268l-.095-.04a.57.57 0 0 1-.27-.68l.042-.096 1.406-2.58h-.48C1.47 11.429 0 10.015 0 8.27 0 6.591 1.362 5.22 3.082 5.12l.271-.006c.234-2.186 1.83-3.97 4.647-3.97m0 1.143c-1.886 0-3.528 1.451-3.528 3.457 0 .318-.29.567-.623.567h-.628c-1.148 0-2.078.89-2.078 1.989 0 1.096.93 1.987 2.078 1.987h9.558c1.148 0 2.078-.89 2.078-1.989 0-1.097-.93-1.987-2.078-1.987h-.628c-.332 0-.623-.25-.623-.567 0-2.03-1.642-3.457-3.528-3.457"
    ></path>
  </svg>
);

export default SvgIcon;
